import { createContext, useContext } from "react";

const UserCardContext = createContext({});

export const UserCardContextProvider = UserCardContext.Provider;
export const UserCardContextConsumer = UserCardContext.Consumer;

export const useUserCardContext = () => useContext(UserCardContext);

export default UserCardContext;
